<script lang="ts" setup>
	const props = defineProps<{
		policy: PolicyResponse | null
		loading?: boolean
		downloading?: boolean
		title?: string
	}>()
	const {
		policyAuthor,
		dependantType,
		hmoId,
		otherMetaInfo,
		policyId,
		isPolicyPending,
		isToBeRemoved,
		dateAdded,
		canAccessHmo,
		isAssigned
	} = usePolicyInfo(() => ({
		policyInfo: props.policy
	}))
	const emit = defineEmits<{
		(event: 'remove'): void
		(event: 'view'): void
	}>()
	const overviewDetails = computed(() => {
		return {
			preview: {
				'Dependant Name': policyAuthor.value.full_name,
				'Phone Number': policyAuthor.value.phone_number,
				'Dependant Type': dependantType.value,
				Gender: policyAuthor.value.gender,
				Relationship: policyAuthor.value.relationship,
				'Hmo Id': hmoId.value
			},
			hmo_img: policyAuthor.value.hmo_url,
			staff_id: otherMetaInfo.value?.staff_policy_id || '',
			id: policyId.value,
			is_pending: isPolicyPending.value
		}
	})
	const downloadingHmo = shallowRef(false)
	const { downloadFile } = useFileExplorer()
	const downloadHmo = async () => {
		if (!hmoId.value) {
			return useNotification().alert({
				message: 'HMO is not available at the moment.',
				status: 404
			})
		}
		resolve(async () => {
			await downloadFile(hmoId.value, `${String(policyAuthor.value.full_name).replace(/ /g, '-')}-hmo.png`)
		}, downloadingHmo)
	}
</script>
<template>
	<div>
		<my-cover-health-waiting-period-banner v-if="isAssigned && !canAccessHmo" type="dependant" :date="dateAdded" />
		<my-cover-policy-card
			v-else
			:details="overviewDetails.preview"
			:loading="loading"
			class="mb-8 w-full"
			:use-footer="Boolean(overviewDetails.hmo_img || overviewDetails.is_pending)"
			file-type="img"
			:pending-id="overviewDetails.is_pending && !overviewDetails.hmo_img"
			:loading-text="(overviewDetails.is_pending && 'Awaiting Dependant Activation') || ''"
		>
			<template #prepend-list-item>
				<div class="mb-5 flex w-full flex-wrap justify-between gap-2 border-b pb-5">
					<h4 class="font-medium text-gray-500">{{ title || 'Dependant' }}</h4>
					<my-cover-plan-status v-if="isToBeRemoved" :plan-details="policy" />
					<button
						v-else-if="policyAuthor?.last_name"
						type="button"
						class="max-w-[120px] rounded-xl border border-gray-400 p-[4px_12px] text-xs text-gray-500 transition hover:border-error-500 hover:text-error-500"
						@click="emit('remove')"
					>
						Remove
					</button>
					<span v-else class="text-xs font-medium text-gray-400">Empty slot</span>
				</div>
			</template>
			<template #button-group>
				<a-button
					:loading="downloading"
					:disabled="downloading"
					size="middle"
					class="!h-auto !rounded-xl !border-primary-2 !p-[8px_20px] !text-sm font-medium tracking-wide !text-primary-2 hover:bg-primary-2 hover:!text-white disabled:!text-primary-500"
					aria-label="download hmo id"
					@click="downloadHmo"
				>
					Download
				</a-button>
				<button type="button" class="!text-sm font-medium tracking-wide text-primary-2" @click="emit('view')">
					View
				</button>
			</template>
		</my-cover-policy-card>
	</div>
</template>
